<script>
import simplebar from "simplebar-vue";

import SideNav from "./side-nav";
import { layoutComputed } from "@/store/helper";
import { SettingModule } from "@/store/modules/settings.module";
/**
 * Sidebar component
 */
export default {
    components: { simplebar, SideNav },
    props: {
        isCondensed: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            required: true,
        },
        width: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...layoutComputed,
        menuItems() {
            return SettingModule.appMenus;
        },
        IsTenantUserHasOrganizationSetting() {
            return SettingModule.IsUserHasOrganizationSettings;
        },
    },
    data() {
        return {
            settings: {
                minScrollbarLength: 60,
            },
            widthss: this.$store ? this.$store.state.layout.layoutWidth : {} || {},
            flyout: {
                visible: false,
                top: 0,
                item: null,
            },
            flyoutHideTimer: null,
            sidebarScrollers: [],
        };
    },
    methods: {
        onRoutechange() {
            this.hideFlyoutNow();
            setTimeout(() => {
                if (document.getElementsByClassName("mm-active").length > 0) {
                    const currentPosition = document.getElementsByClassName("mm-active")[0].offsetTop;
                    if (currentPosition > 500) this.$refs.currentMenu.SimpleBar.getScrollElement().scrollTop = currentPosition + 300;
                }
            }, 300);
        },
        hasItems(item) {
            return item && item.subItems !== undefined && item.subItems !== null ? item.subItems.length > 0 : false;
        },
        headerOffset() {
            const header = document.getElementById("page-topbar");
            return header ? header.offsetHeight : 70;
        },
        bindSidebarScroll() {
            this.unbindSidebarScroll();
            const wrappers = this.$el.querySelectorAll(".simplebar-content-wrapper");
            this.sidebarScrollers = Array.prototype.slice.call(wrappers);
            this.sidebarScrollers.forEach((wrapper) => {
                wrapper.addEventListener("scroll", this.hideFlyoutNow);
            });
        },
        unbindSidebarScroll() {
            this.sidebarScrollers.forEach((wrapper) => {
                wrapper.removeEventListener("scroll", this.hideFlyoutNow);
            });
            this.sidebarScrollers = [];
        },
        onCollapsedItemEnter(payload) {
            if (this.flyoutHideTimer) {
                clearTimeout(this.flyoutHideTimer);
                this.flyoutHideTimer = null;
            }

            this.flyout.item = payload.item;
            this.flyout.top = payload.top;
            this.flyout.visible = true;
            this.$nextTick(() => {
                this.positionFlyout(payload.item, payload.top);
            });
        },
        onCollapsedItemLeave(event) {
            const flyout = this.$refs.collapsedFlyout;
            const next = event && event.relatedTarget;
            if (flyout && next && flyout.contains(next)) {
                return;
            }

            if (this.flyoutHideTimer) {
                clearTimeout(this.flyoutHideTimer);
            }

            this.flyoutHideTimer = setTimeout(() => {
                this.hideFlyoutNow();
            }, 120);
        },
        onFlyoutEnter() {
            if (this.flyoutHideTimer) {
                clearTimeout(this.flyoutHideTimer);
                this.flyoutHideTimer = null;
            }
        },
        hideFlyoutNow() {
            if (this.flyoutHideTimer) {
                clearTimeout(this.flyoutHideTimer);
                this.flyoutHideTimer = null;
            }

            this.flyout.visible = false;
            this.flyout.item = null;
        },
        positionFlyout(item, top) {
            if (!this.flyout.item || this.flyout.item !== item) {
                return;
            }

            const el = this.$refs.collapsedFlyout;
            if (!el) {
                return;
            }

            const minTop = this.headerOffset();
            const margin = 8;
            const height = el.offsetHeight;
            const available = window.innerHeight - margin;
            el.style.maxHeight = "";
            el.style.overflowY = "";

            if (height > available - minTop) {
                this.flyout.top = minTop;
                el.style.maxHeight = available - minTop + "px";
                el.style.overflowY = "auto";
                return;
            }

            this.flyout.top = Math.max(minTop, Math.min(top, available - height));
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.bindSidebarScroll();
        });
    },
    beforeDestroy() {
        this.unbindSidebarScroll();
        if (this.flyoutHideTimer) {
            clearTimeout(this.flyoutHideTimer);
        }
    },
    watch: {
        $route: {
            handler: "onRoutechange",
            immediate: true,
            deep: true,
        },
        isCondensed() {
            this.hideFlyoutNow();
            this.$nextTick(() => {
                this.bindSidebarScroll();
            });
        },
        type: {
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    switch (newVal) {
                        case "dark":
                            document.body.setAttribute("data-sidebar", "dark");
                            document.body.removeAttribute("data-topbar");
                            document.body.removeAttribute("data-sidebar-size");
                            break;
                        case "light":
                            document.body.setAttribute("data-topbar", "dark");
                            document.body.removeAttribute("data-sidebar");
                            document.body.removeAttribute("data-sidebar-size");
                            document.body.classList.remove("vertical-collpsed");
                            break;
                        case "compact":
                            document.body.setAttribute("data-sidebar-size", "small");
                            document.body.setAttribute("data-sidebar", "dark");
                            document.body.classList.remove("vertical-collpsed");
                            document.body.removeAttribute("data-topbar", "dark");
                            break;
                        case "icon":
                            document.body.setAttribute("data-keep-enlarged", "true");
                            document.body.classList.add("vertical-collpsed");
                            document.body.setAttribute("data-sidebar", "dark");
                            document.body.removeAttribute("data-topbar", "dark");
                            break;
                        case "colored":
                            document.body.setAttribute("data-sidebar", "colored");
                            document.body.removeAttribute("data-keep-enlarged");
                            document.body.classList.remove("vertical-collpsed");
                            document.body.removeAttribute("data-sidebar-size");
                            break;
                        default:
                            document.body.setAttribute("data-sidebar", "dark");
                            break;
                    }
                }
            },
        },
        width: {
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    switch (newVal) {
                        case "boxed":
                            document.body.setAttribute("data-layout-size", "boxed");
                            document.body.removeAttribute("data-layout-scrollable");
                            break;
                        case "fluid":
                            document.body.setAttribute("data-layout-mode", "fluid");
                            document.body.removeAttribute("data-layout-size");
                            document.body.removeAttribute("data-layout-scrollable");
                            break;
                        case "scrollable":
                            document.body.setAttribute("data-layout-scrollable", "true");
                            document.body.removeAttribute("data-layout-mode");
                            document.body.removeAttribute("data-layout-size");
                            break;
                        default:
                            document.body.setAttribute("data-layout-mode", "fluid");
                            break;
                    }
                }
            },
        },
    },
};
</script>

<template>
    <!-- ========== Left Sidebar Start ========== -->
    <div class="vertical-menu" :class="{ 'org-settings-sidebar-disabled': !IsTenantUserHasOrganizationSetting }">
        <simplebar v-if="!isCondensed" :settings="settings" ref="currentMenu" id="my-element" class="h-100">
            <SideNav :key="menuItems.length > 0" :flyout-item-id="flyout.item && flyout.item.id" @collapsed-item-enter="onCollapsedItemEnter" @collapsed-item-leave="onCollapsedItemLeave" />
        </simplebar>

        <simplebar v-else class="h-100">
            <SideNav :key="menuItems.length > 0" :flyout-item-id="flyout.item && flyout.item.id" @collapsed-item-enter="onCollapsedItemEnter" @collapsed-item-leave="onCollapsedItemLeave" />
        </simplebar>

        <div v-show="flyout.visible && flyout.item" ref="collapsedFlyout" class="collapsed-sidebar-flyout" :style="{ top: flyout.top + 'px' }" @mouseenter="onFlyoutEnter" @mouseleave="onCollapsedItemLeave" @click="hideFlyoutNow">
            <router-link v-if="flyout.item && !hasItems(flyout.item)" :to="flyout.item.link" class="collapsed-sidebar-flyout__label">{{ $t(flyout.item.label) }}</router-link>
            <span v-else-if="flyout.item" class="collapsed-sidebar-flyout__label">{{ $t(flyout.item.label) }}</span>
            <ul v-if="flyout.item && hasItems(flyout.item)" class="collapsed-sidebar-flyout__menu list-unstyled">
                <li v-for="(subitem, index) in flyout.item.subItems" :key="index">
                    <router-link v-if="!hasItems(subitem)" :to="subitem.link">{{ $t(subitem.label) }}</router-link>
                    <a v-else class="has-nested" href="javascript:void(0);">{{ $t(subitem.label) }}</a>
                    <ul v-if="hasItems(subitem)" class="collapsed-sidebar-flyout__menu collapsed-sidebar-flyout__menu--nested list-unstyled">
                        <li v-for="(subSubitem, subIndex) in subitem.subItems" :key="subIndex">
                            <router-link :to="subSubitem.link">{{ $t(subSubitem.label) }}</router-link>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
    <!-- Left Sidebar End -->
</template>
